import { CULLER_BATCH_SIZE, CullerConnections } from "./culler-connection"
import type { CullerWorker, CullingWorkerInput } from "./culler.worker"
import { Remote } from "@/utils/peer"
import PQueue from "p-queue"

const workers: Remote<CullerWorker>[] = await Promise.all(
	CullerConnections.map((connection) => connection.connect()),
)

class CullerPool {
	private readonly queue = new PQueue({ concurrency: workers.length })
	private readonly availableWorkers = [...workers]

	public async extractCullingData(inputs: CullingWorkerInput[]) {
		return await this.queue.add(async () => {
			const worker = this.availableWorkers.pop()
			if (!worker) throw new Error("No culler worker available")

			try {
				return await worker.extractCullingData(inputs, CULLER_BATCH_SIZE)
			} finally {
				this.availableWorkers.push(worker)
			}
		})
	}

	public async cleanupModels() {
		await this.queue.onIdle()
		await Promise.all(workers.map((worker) => worker.cleanupModels()))
	}

	public async reset() {
		await this.queue.onIdle()
		await Promise.all(CullerConnections.map((connection) => connection.reset()))
	}

	public async getTotalBytesUsage() {
		const usage = await Promise.all(workers.map((worker) => worker.getTotalBytesUsage()))
		return usage.reduce((total, bytes) => total + bytes, 0)
	}
}

export const Culler = new CullerPool()
